import { type ComponentType } from 'react';
import { type WithTranslation, withTranslation } from '@wix/yoshi-flow-editor';

/**
 * @deprecated
 * This is an alias for `withTranslation()` HOC that yoshi provides.
 *
 * Please use `withTranslation()` directly with `WithTranslation` for types.
 **/
const withTranslate = <T extends Pick<WithTranslation, 't'>>(Component: ComponentType<T>) =>
  withTranslation()(Component);

export default withTranslate;
